<template>
  <v-dialog
    persistent
    hide-overlay
    :width="width"
    v-model="value"
    :fullscreen="fullscreen"
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-card-title primary-title class="px-2 py-1 primary white--text">
        <v-btn
          flat
          icon
          v-if="print"
          class="ma-0"
          color="white"
          @click="$emit('print')"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <div v-else class="pl-2 pr-2 font-weight-medium">{{ title }}</div>
        <v-spacer />
        <v-btn
          flat
          icon
          class="ma-0"
          color="white"
          @click="$emit('input', false)"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <slot class="pt-2" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      default: false,
      required: true
    },
    title: {
      default: ""
    },
    print: { default: false },
    fullscreen: { default: false },
    width: {
      default: "800"
    }
  }
};
</script>
